var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.80369 0.31665H11.8982C12.0828 0.31665 12.2634 0.370264 12.4181 0.470975C12.5727 0.571686 12.6948 0.715157 12.7695 0.883952C12.8442 1.05275 12.8682 1.2396 12.8387 1.42179C12.8092 1.60399 12.7273 1.77369 12.6032 1.91026L8.74363 6.15577V9.4774C8.74363 9.63425 8.70491 9.78867 8.6309 9.92695C8.55689 10.0652 8.44989 10.1831 8.31938 10.2701L6.43948 11.5234C6.296 11.619 6.12925 11.674 5.957 11.6823C5.78476 11.6906 5.61349 11.652 5.46145 11.5707C5.30941 11.4893 5.1823 11.3682 5.09369 11.2203C5.00507 11.0723 4.95827 10.9031 4.95827 10.7307V6.15577L1.09872 1.91026C0.974563 1.77369 0.892749 1.60399 0.863222 1.42179C0.833696 1.2396 0.857728 1.05275 0.932398 0.883952C1.00707 0.715157 1.12916 0.571685 1.28384 0.470975C1.43851 0.370264 1.61911 0.31665 1.80369 0.31665ZM1.83259 1.28217H11.8693L8.02588 5.50994C7.86646 5.68532 7.77812 5.91382 7.77812 6.15082V9.47056L5.92379 10.7068V6.15082C5.92379 5.91382 5.83545 5.68532 5.67602 5.50995L1.83259 1.28217Z",
    fill: "#676879"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.3bfed83f43e5c0e3bc8302e5f91fd7f9.svg";
export { ForwardRef as ReactComponent };